import { cargoReleaseTypes } from './actionTypes';

export const getCargoReleaseList = (payload: any) => ({
  type: cargoReleaseTypes.GET_CARGORELEASE,
  payload,
});

export const getCargoReleaseListSuccess = (payload: any) => ({
  type: cargoReleaseTypes.GET_CARGORELEASE_SUCCESS,
  payload,
});

export const getCargoReleaseListFail = (error: any) => ({
  type: cargoReleaseTypes.GET_CARGORELEASE_FAIL,
  payload: error,
});

export const getMilestoneConfigCR = (payload?: any)=>{
  return{
    type: cargoReleaseTypes.GET_MILESTONESCONFIG_CR,
    payload,
  }
}

export const getMilestoneConfigCRSuccess = (payload:any)=>{
  return{
    type: cargoReleaseTypes.GET_MILESTONESCONFIG_CR_SUCCESSS,
    payload,
  }
}

export const getMilestoneConfigCRFail = (payload:any)=>{
  return{
    type: cargoReleaseTypes.GET_MILESTONESCONFIG_CR_FAIL,
    payload,
  }
}
